import '@vfde-brix/simple-table/dist/styles.css';
import { createSimpleTableComponent } from '@vfde-brix/simple-table';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-simple-table', createSimpleTableComponent, NO_PATTERN_BUSINESS_LOGIC);
